var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-invalid"},[_c('div',{staticClass:"logo"},[_vm._v("CHANEL")]),_c('div',{staticClass:"invalid-content"},[_c('div',{staticClass:"content-title"},[_vm._v("二维码已失效")]),_c('div',{staticClass:"info-text"},[_vm._v("敬请联系您的精品顾问获取新的二维码")])])])
}]

export { render, staticRenderFns }